module.exports = __webpack_public_path__ + "static/media/mern-stack.90616a5d.jpg";